import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Link} from 'react-router-dom'

function ImageG() {
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState('');
  const [error, setError] = useState(null);

  const generateImage = async () => {
    try {
      const response = await axios.post('https://api.openai.com/v1/images/generations', {
        model: 'image-alpha-001',
        prompt: description,
      }, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
          'Content-Type': 'application/json'
        }
      });
      setImage(response.data.data[0].url);
      setError(null);
    } catch (error) {
      setError('An error occurred while generating the image. Please try again later.');
    }
  };

  return (
    <div className='App'>
        <nav aria-label="breadcrumb" className='mt-2'>
  <ol className="breadcrumb text-dark ">
    <li className="breadcrumb-item "><Link to="/">Home</Link></li>
    <li className="breadcrumb-item active" aria-current="page">DDAI Image Generator</li>
  </ol>
</nav>
    <div className="container mt-5">
      <h1 className="text-center">Image Generation</h1>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="form-group">
        <label htmlFor="description">Description</label>
        <textarea
          className="form-control"
          id="description"
          rows="3"
          value={description}
          onChange={e => setDescription(e.target.value)}
        />
      </div>
      <button className="btn btn-warning" onClick={generateImage}>Generate Image</button>
      <div className="mt-5">
        {image && <img src={image} alt="Generated Image" className="img-fluid" />}
      </div>
    </div>
    </div>
  );
}

export default ImageG;
